/* import __COLOCATED_TEMPLATE__ from './copilot-access-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    componentAttrs: {
      description: string;
    };
    item: {
      text: string;
      isSelected: boolean;
    };
  };
}

const CopilotAccessDropdownItem = templateOnlyComponent<Signature>();
export default CopilotAccessDropdownItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::TeammateList::CopilotAccessDropdownItem': typeof CopilotAccessDropdownItem;
  }
}
